// extracted by mini-css-extract-plugin
module.exports = {"section":"Overview_section__XLXdQ","overview-columns":"Overview_overview-columns__53Eyq"};